import BankAccount from './components/BankAccount'
import Calendar from './components/Calendar'
import Welcome from './components/Welcome'

const Invitation = () => {
  return (
    <>
      <Welcome />
      <Calendar />
      <BankAccount />
    </>
  )
}

export default Invitation
